/**
 *
 * Asynchronously loads the component for StudentJobsAndDrives
 *
 */

import { lazyLoad } from 'utils/loadable';

export const StudentJobsAndDrives = lazyLoad(
  () => import('./index'),
  module => module.default,
);